import { Endpoint } from "../config";

export type SignEndpointType = "documentToBeSigned" | "signedDocuments";

export const signEndpoints: Record<SignEndpointType, Endpoint> = {
  documentToBeSigned: {
    url: "document-to-be-signed/",
  },
  signedDocuments: {
    url: "signed-documents/",
  },
};
